import { render } from "./RegistryView.vue?vue&type=template&id=fd9ccbda&scoped=true"
import script from "./RegistryView.vue?vue&type=script&lang=js"
export * from "./RegistryView.vue?vue&type=script&lang=js"

import "./RegistryView.vue?vue&type=style&index=0&id=fd9ccbda&lang=css"
import "./RegistryView.vue?vue&type=style&index=1&id=fd9ccbda&scoped=true&lang=css"

import exportComponent from "/Applications/PROJECTS/HMS-MAIN/PORTAL/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-fd9ccbda"]])

export default __exports__